import { render, staticRenderFns } from "./service-plan-form.vue?vue&type=template&id=b1351b62"
import script from "./service-plan-form.vue?vue&type=script&lang=js"
export * from "./service-plan-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports